"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.replace");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Top10Listv2',
  props: {
    mode: {
      type: Boolean,
      default: false
    },
    data: {
      default: []
    }
  },
  data: function data() {
    return {
      visibility: 'all'
    };
  },
  computed: {
    label: function label() {
      return this.mode ? this.$t('dashboard.merchant.smsUnit') : this.$t('dashboard.moneyUnit');
    }
  },
  methods: {
    formatNumber: function formatNumber(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
exports.default = _default;